/** Chinese text: Exam Prep (Academy), Study, school learning, school compare, guides. See ../portalZh.ts. */
export const ZH_STUDY: Readonly<Record<string, string>> = {
  'Not scheduled': '未安排',
  'Study settings': '学习设置',
  "Your child's Study settings": '你孩子的学习设置',
  'Support without taking over': '支持，但不越俎代庖',
  'A small weekly target and one Tutor boundary. These settings apply only to this child.':
    '一个小小的每周目标，加一条导师边界。这些设置只对这个孩子生效。',
  'Study Sessions per 7 days': '每 7 天的学习次数',
  'No target yet': '暂无目标',
  'Allow full worked explanations (H4)': '允许完整的解题讲解（H4）',
  'Save settings': '保存设置',
  'Settings saved.': '设置已保存。',
  'Could not save settings. Please try again.': '无法保存设置，请重试。',
  'Turning off H4 does not affect H0–H3. Assessment mode keeps its stricter limits.':
    '关闭 H4 不影响 H0–H3。测评模式仍保持更严格的限制。',
  'Study report categories': '学习报告分类',
  'Learning records': '学习记录',
  'Tutor method': '导师教学方法',
  'See your child’s learning records': '查看孩子的学习记录',
  'Loading the learning support report…': '正在加载学习支持报告…',
  'Study report unavailable': '暂时无法查看学习报告',
  "We couldn't load this report. It may be temporarily unavailable, or it may not belong to your family.":
    '无法加载这份报告。可能暂时不可用，也可能不属于你的家庭。',
  'Back to family Study': '返回家庭学习',
  'Learning Support Report': '学习支持报告',
  "{name}'s study this week": '{name}本周的学习',
  "A seven-day view of Study Sessions, practice questions, learning tools, Tutor support and reviews. This report uses learning evidence—not the student's private working, submitted answers or full Tutor conversations.":
    '这是过去七天的学习概览，涵盖学习次数、练习题、学习工具、导师辅导和复习。报告只使用学习证据，不包含学生的私人演算、提交的答案或完整的导师对话。',
  'Manage Study access': '管理学习权限',
  'Weekly history': '每周记录',
  'Weekly Study Session target: {completed} of {target} completed — target met.':
    '每周学习目标：已完成 {completed} / {target} 次，目标达成。',
  'Weekly Study Session target: {completed} of {target} completed.':
    '每周学习目标：已完成 {completed} / {target} 次。',
  'Study support prompts': '学习支持提示',
  'Support prompts': '支持提示',
  'Activity prompts are not risk scores, grades or mastery judgments.':
    '活动提示不是风险评分、成绩或掌握程度的判断。',
  'No Study evidence yet': '还没有学习记录',
  'The report will begin after {name} completes a Study Session, practice question or learning-tool activity. We do not turn missing evidence into a zero score.':
    '{name}完成一次学习、一道练习题或一项学习工具活动后，报告才会开始生成。我们不会把缺少记录当作零分。',
  'Early evidence only. One completed session can show activity, but it cannot establish mastery or a trend.':
    '目前只有早期记录。一次完成的学习能反映学习活动，但还不能说明掌握程度或趋势。',
  'Study summary': '学习概览',
  'Study sessions': '学习次数',
  'Practice questions': '练习题',
  'Tool completions': '工具完成次数',
  'Reviews due': '待复习',
  'AI support': 'AI 辅导',
  'How Tutor was used': '导师的使用情况',
  'AI Tutor': 'AI 导师',
  '1 session finished with an attempt and no Tutor turn.':
    '有 1 次学习是先自己尝试、没有向导师提问就完成的。',
  '{count} sessions finished with an attempt and no Tutor turn.':
    '有 {count} 次学习是先自己尝试、没有向导师提问就完成的。',
  '1 Tutor turn used {stars}★.': '导师回应了 1 次，用了 {stars}★。',
  '{count} Tutor turns used {stars}★.': '导师回应了 {count} 次，用了 {stars}★。',
  'The answer was shown after 1 failed practice attempt.':
    '有 1 次练习尝试未答对后，系统展示了答案。',
  'The answer was shown after {count} failed practice attempts.':
    '有 {count} 次练习尝试未答对后，系统展示了答案。',
  'Tutor help levels': '导师辅助级别',
  'Next support action': '下一步支持行动',
  '1 review scheduled for later.': '稍后还有 1 次复习。',
  '{count} reviews scheduled for later.': '稍后还有 {count} 次复习。',
  'Subjects this week': '本周学科',
  Subject: '学科',
  '1 Tutor turn': '导师回应 1 次',
  '{count} Tutor turns': '导师回应 {count} 次',
  'no Tutor help': '未使用导师帮助',
  'highest H{level}': '最高 H{level}',
  '1 practice question · {correct} correct': '1 道练习题 · 答对 {correct} 道',
  '{count} practice questions · {correct} correct': '{count} 道练习题 · 答对 {correct} 道',
  '1 verified tool completion': '1 次已验证的工具完成',
  '{count} verified tool completions': '{count} 次已验证的工具完成',
  'Recent learning evidence': '近期学习记录',
  'Review the source and try one similar question.': '回顾原题出处，再试一道类似的题。',
  'Attempt saved': '已保存尝试',
  'Attempt not recorded': '未记录尝试',
  'No Tutor help': '未使用导师帮助',
  'Highest help H{level}': '最高辅助 H{level}',
  Review: '复习',
  'Level not set': '未设置年级',
  Practice: '练习',
  'Answered correctly': '答对了',
  'Needs another try': '需要再试一次',
  'The answer was shown after this attempt; the submitted answer stays private.':
    '这次尝试后系统展示了答案；提交的答案不会公开。',
  'The submitted answer stays private.': '提交的答案不会公开。',
  Chemistry: '化学',
  'Completed a scheduled review': '完成了一次计划复习',
  'Balanced a verified equation challenge': '配平了一道已验证的方程式挑战',
  '1 adjustment · highest help H{level}.': '调整 1 次 · 最高辅助 H{level}。',
  '{count} adjustments · highest help H{level}.': '调整 {count} 次 · 最高辅助 H{level}。',
  'This is practice evidence, not a mastery score.': '这是练习记录，不是掌握程度评分。',
  'Next review': '下次复习',
  'Interactive tools this week': '本周的互动工具',
  "Tools your child opened and the predictions or checks they answered. Each tool judges its own answers, so this shows practice, not a mastery score. Your child's actual answers are not shared.":
    '孩子打开过的工具，以及回答过的预测或检查题。每个工具自行判断答案，所以这里反映的是练习情况，不是掌握程度评分。孩子的具体答案不会分享。',
  'Opened 1 time': '打开 1 次',
  'Opened {count} times': '打开 {count} 次',
  'no predictions or checks answered': '未回答预测或检查题',
  '{correct} of 1 answer right': '1 个答案中答对 {correct} 个',
  '{correct} of {answers} answers right': '{answers} 个答案中答对 {correct} 个',
  'Privacy boundary': '隐私边界',
  "This report does not include the student's Study attempt text, submitted practice answer, equation input, coefficients or full Tutor transcript. It shows only the minimum evidence needed to support learning.":
    '这份报告不包含学生的学习尝试文字、提交的练习答案、方程式输入、系数或完整的导师对话记录，只显示支持学习所需的最少记录。',
  'Learning with Tutor': '和导师一起学习',
  'How the Tutor helps your child learn': '导师如何帮助孩子学习',
  'Our aim is for your child to choose evidence, explain an idea and try again. Tutor help supports that thinking. Finishing with help does not establish independent ability.':
    '我们的目标是让孩子自己选择依据、解释想法，并再试一次。导师的帮助是为了支持这种思考。借助帮助完成任务，并不代表孩子已经能独立完成。',
  'English example: Scripted illustration · Not a live learning feature · Trial requires educator review and publication':
    '英语示例：脚本演示 · 并非正在运行的学习功能 · 试用需要教育工作者审核并发布',
  'Close Tutor guide': '收起导师指南',
  'Read the method and English example': '阅读教学方法和英语示例',
  'Tutor guide categories': '导师指南分类',
  'Learning method': '学习方法',
  'Dialogue example': '对话示例',
  'Common questions': '常见问题',
  'Tutor functions and evidence limits': '导师功能与证据的局限',
  'Who does the thinking?': '谁来思考？',
  'Your child owns the judgment, evidence and explanation. These functions explain the method; they do not approve schoolwork use or promise learning gains.':
    '判断、依据和解释都由孩子自己完成。这些功能只是说明教学方法，并不代表允许用于学校作业，也不承诺学习成效。',
  'Your child tries first': '孩子先自己尝试',
  'Tutor teaches the difficulty': '导师讲解难点',
  'Your child retries': '孩子再试一次',
  'A new text checks independent application': '用新文本检验能否独立运用',
  'See all seven functions and their limits': '查看全部七项功能及其局限',
  Tutor: '导师',
  'Evidence and limits': '依据与局限',
  'Start with a source': '从一份材料开始',
  'Reads the selected text and checks what the task asks.': '阅读选定的文本，弄清任务要求。',
  'Clarifies the task or an unfamiliar word before offering analysis.':
    '在给出分析之前，先解释任务或陌生的词。',
  'An uploaded source is not proof that AI help is permitted. The separate English trial requires reviewed, published original materials.':
    '上传的材料并不能证明允许使用 AI 帮助。单独的英语试用需要经过审核并发布的原创材料。',
  'Make their own attempt': '先自己尝试',
  'Chooses an idea, evidence and an explanation, or identifies where they are stuck.':
    '选择一个想法、依据和解释，或指出自己卡在哪里。',
  'Uses that attempt to decide what help would be useful.': '根据这次尝试判断哪种帮助有用。',
  'A saved attempt records participation. It does not establish the quality of the thinking.':
    '保存的尝试只记录孩子参与过，并不能说明思考的质量。',
  'Get the right amount of help': '得到恰到好处的帮助',
  'Makes choices, tries the suggested method and returns to the task.':
    '自己做选择，尝试建议的方法，然后回到任务中。',
  'May clarify, hint, explain or model a method. Help should reduce when the child can continue.':
    '可能会澄清、提示、讲解或示范方法。孩子能继续时，帮助应当减少。',
  'Tutor help exists in Study. The English trial uses the learner’s attempts and requested help; its effectiveness is not established.':
    '学习中提供导师帮助。英语试用会参考学习者的尝试和主动请求的帮助，其效果尚未得到证实。',
  'Connect ideas and evidence': '把想法和依据联系起来',
  'Builds and checks the link between an idea, a detail and their explanation.':
    '建立并检查想法、细节和解释之间的联系。',
  'Can help locate a missing link without choosing the child’s final judgment.':
    '可以帮助找出缺失的环节，但不替孩子做最终判断。',
  'The English trial Answer Map supports the child’s reasoning. A complete map is not learning proof.':
    '英语试用中的答案图用来支持孩子的推理。填满的图并不是学会的证明。',
  'Check against the source': '对照原文检查',
  'Checks quotations, context and whether the evidence supports the claim.':
    '检查引文、上下文，以及依据是否支持观点。',
  'Prompts a source check and identifies uncertainty.': '提示孩子回到原文核对，并指出不确定之处。',
  'AI can misread or invent details. An exact quotation check does not establish whether that evidence supports the interpretation.':
    'AI 可能误读或编造细节。引文完全一致，并不能说明这条依据支持这样的解读。',
  'Try a new task, then return later': '尝试新任务，之后再回来检查',
  'Tries a reviewed new text with help recorded, and returns for a later check.':
    '在记录所用帮助的前提下尝试一篇经过审核的新文本，之后再回来检查。',
  'Keeps access accommodations and records any analysis help used.':
    '保留无障碍设置，并记录用过的分析帮助。',
  'Study has practice and reviews. The separate English trial uses different texts and records support use. A retry of the same answer is not transfer.':
    '学习中有练习和复习。单独的英语试用会使用不同的文本，并记录帮助的使用情况。重复同一个答案不算迁移运用。',
  'Give adults a useful summary': '给成年人一份有用的总结',
  'Keeps ownership of their private working and explanation.':
    '孩子的私人演算和解释始终归孩子自己。',
  'Makes recorded activity, support and next steps understandable to authorised adults.':
    '让获得授权的成年人能看懂已记录的活动、帮助和下一步。',
  'English trial process records show attempts, help and checks when available. The summary below is fictional, not your child’s evidence.':
    '英语试用的过程记录（如有）会显示尝试、帮助和检查。下面的总结是虚构的，并不是你孩子的学习记录。',
  'Fictional English Tutor example': '虚构的英语导师示例',
  'Scripted demonstration · English design example': '脚本演示 · 英语设计示例',
  'One passage, different help': '同一段文字，不同的帮助',
  'Asha is a character in this original passage. The learner and Tutor replies are fictional, not your child’s records or a live AI demonstration.':
    'Asha 是这段原创文字里的人物。学习者和导师的回复都是虚构的，不是你孩子的记录，也不是真实的 AI 演示。',
  'Task: How does the writer suggest that Asha is nervous?': '任务：作者是如何暗示 Asha 很紧张的？',
  'Choose a fictional learner situation to see how the help changes.':
    '选择一种虚构的学习情况，看看帮助会怎样变化。',
  'Fictional learner situations': '虚构的学习情况',
  'Needs the method': '需要方法',
  'Gets stuck': '卡住了',
  'Ready for less help': '可以少一点帮助了',
  '{label} walkthrough': '{label}的过程演示',
  'A hint points the child back to the task. A worked example teaches the method on another text. Help fades when the child can continue, rather than after a fixed number of days.':
    '提示会把孩子带回任务本身。示范例子则在另一篇文本上讲解方法。帮助会在孩子能继续时逐渐减少，而不是过了固定天数才减少。',
  'Fictional adult summary': '虚构的成年人总结',
  'Sample adult summary · Not your child’s record': '成年人总结示例 · 不是你孩子的记录',
  'What an adult could learn from this process': '成年人能从这个过程了解到什么',
  'View sample process summary': '查看过程总结示例',
  Goal: '目标',
  'Use a character’s actions to support an interpretation.': '用人物的行为来支持自己的解读。',
  'Learner work': '学习者的作答',
  'Initial attempt recorded. A detail was selected and an explanation revised. Revision quality awaits review.':
    '已记录第一次尝试。孩子选了一个细节并修改了解释，修改的质量有待审核。',
  'Support used': '用到的帮助',
  'A method explanation and a worked example on another text.':
    '一次方法讲解，以及在另一篇文本上的示范例子。',
  'One comparison hint and a worked example on another text.':
    '一次对比提示，以及在另一篇文本上的示范例子。',
  'A source-check question; no worked example.': '一个回到原文核对的问题；没有示范例子。',
  'Independent check': '独立检查',
  'Not yet attempted. Independent ability is not established.':
    '尚未尝试。独立完成的能力还没有得到证实。',
  'Next step': '下一步',
  'Try a reviewed new text, record any help, and return for a later check.':
    '尝试一篇经过审核的新文本，记录用过的帮助，之后再回来检查。',
  'This fictional summary omits private answer text. Actual English trial records, when available, show recorded steps and distinguish support use from answer quality.':
    '这份虚构的总结不含私人答案文字。真实的英语试用记录（如有）会显示已记录的步骤，并区分帮助的使用和答案的质量。',
  'Questions parents ask about Tutor': '家长常问的导师问题',
  'Questions you might have': '你可能会有的疑问',
  'Is getting help a problem?': '得到帮助有问题吗？',
  'Help is a valid part of learning when the task permits it. We record support rather than treat supported work as independent mastery.':
    '在任务允许的情况下，帮助是学习的正当组成部分。我们会记录所得的帮助，而不会把有帮助下完成的作业当作独立掌握。',
  'Can my child use this for schoolwork?': '我的孩子可以用它做学校作业吗？',
  'The school and the specific task set the rules. Parent settings do not grant permission. If rules are unclear, check or use separate practice.':
    '规则由学校和具体任务决定，家长设置不能代表许可。规则不明确时，请先确认，或另外做练习。',
  'What if the AI is wrong?': '如果 AI 说错了怎么办？',
  'Check the original source. AI feedback can be mistaken or uncertain. Ask for human review when an interpretation or result matters.':
    '请核对原始材料。AI 的反馈可能有误或不确定。解读或结果很重要时，请找人工审核。',
  'What can I see?': '我能看到什么？',
  'Your family report shows authorised learning evidence. It does not reveal private answers, working or full Tutor conversations. School reports follow their own sharing permissions.':
    '你的家庭报告会显示已获授权的学习记录，不会透露私人答案、演算过程或完整的导师对话。学校报告遵循各自的分享权限。',
  'Does this prove my child has improved?': '这能证明孩子进步了吗？',
  'Counts, a polished answer and a completed example do not prove improvement. Reviewed new-task and later checks provide different evidence, with any help recorded.':
    '次数、一份漂亮的答案和一个做完的例子，都不能证明进步。经过审核的新任务和之后的检查才能提供不同的依据，并会记录所用的帮助。',
  'Ask your child: “Which detail supports your idea, and why?” Give them time to explain. Avoid choosing the evidence or writing the response for them.':
    '问问孩子：“哪个细节支持你的想法？为什么？”给孩子时间解释。请避免替孩子选择依据或写出回答。',
  'You can discuss what a helped revision shows, and what still needs checking on a new task. There is no quiz required to use this guide.':
    '你可以聊聊有帮助下的修改说明了什么，以及换一个新任务时还需要检查什么。使用这份指南不需要做任何测验。',
  'Guide v0.6 · 7 October 2026 · English design under exploration':
    '指南 v0.6 · 2026 年 10 月 7 日 · 英语设计仍在探索中',
  'Close guide and return to report': '收起指南并返回报告',
  '“I do not know how to find evidence for a feeling.”': '“我不知道怎么为一种感受找依据。”',
  'Explains that actions can suggest feelings. On a different text, Noah displays a certificate facing the door. This could suggest he wants recognition.':
    '解释行为可以暗示感受。在另一篇文本里，Noah 把证书摆在朝向门口的位置，这可能说明他希望得到认可。',
  Why: '原因',
  'The Tutor makes the method explicit using another text. The child still has to choose evidence from Asha’s passage.':
    '导师用另一篇文本把方法讲清楚，但孩子仍然要自己从 Asha 的那段文字里选择依据。',
  'Returns to Asha’s passage, chooses the repeated smoothing and explains why that action could suggest unease.':
    '回到 Asha 的那段文字，选中她反复抚平笔记一角的动作，并解释为什么这个动作可能暗示不安。',
  'Asks the child to check their explanation against the source. It does not write the child’s final response.':
    '请孩子对照原文检查自己的解释，不会替孩子写出最终答案。',
  'The child chooses the detail and supplies the explanation. The example alone does not show independent ability.':
    '细节由孩子选择，解释也由孩子给出。仅凭这个例子，不能说明孩子已能独立完成。',
  '“She is nervous because someone calls her name.”': '“她很紧张，因为有人叫她的名字。”',
  '“Being called could also make someone excited. Would you check her actions or her words?”':
    '“被叫到名字也可能让人兴奋。你想看看她的动作，还是她的话？”',
  'The hint responds to this attempt. The child chooses which part of the passage to inspect.':
    '提示是针对这次尝试给出的。要查看文段的哪一部分，由孩子自己选择。',
  'Chooses actions, but still cannot explain what they suggest.':
    '选了动作，但仍然说不出这些动作暗示了什么。',
  'Models another text: Noah displays a certificate facing the door. Visitors can see it, so he may want recognition.':
    '用另一篇文本示范：Noah 把证书摆在朝向门口的位置，访客能看到，所以他可能希望得到认可。',
  'When a hint is not enough, the Tutor teaches a method. It leaves the current passage for the child to interpret.':
    '提示不够时，导师会讲解方法，而当前这段文字仍留给孩子自己去解读。',
  '“She smooths the corner twice. Repeating this small movement could suggest she is unsettled.”':
    '“她把一角抚平了两次。这个反复的小动作可能说明她心神不宁。”',
  'Asks the child to check that detail and explain the link in their own words.':
    '请孩子核对这个细节，并用自己的话解释其中的联系。',
  'The child changes both the evidence and the explanation. Help remains part of this record.':
    '孩子同时调整了依据和解释。所得的帮助也会保留在这份记录中。',
  'Chooses the repeated smoothing and explains that a small repeated movement may suggest nervousness.':
    '选中反复抚平的动作，并解释这种反复的小动作可能暗示紧张。',
  '“Which words support your idea? Could that action have another explanation?”':
    '“哪些词句支持你的想法？这个动作会不会还有别的解释？”',
  'The Tutor checks the reasoning without giving a model answer when the child can already continue.':
    '孩子已经能继续时，导师只检查推理，不提供标准答案。',
  'Checks the source and revises the claim to say the action “could suggest” nervousness.':
    '核对原文后，把观点改成这个动作“可能暗示”紧张。',
  'Suggests a reviewed new text for a later check with less help.':
    '建议之后用一篇经过审核的新文本，在更少帮助下再检查一次。',
  'Support reduces in response to the child’s work. Independent performance still needs separate evidence.':
    '帮助会根据孩子的作答情况减少。独立完成的表现仍需另外的依据。',
  'The school information could not load. Try again.': '无法加载学校信息，请重试。',
  'From your child’s school': '来自孩子的学校',
  'See published learning, attendance and reports for a verified school relationship. This access keeps the school and responsible teacher in control of the student account.':
    '查看已验证的学校关系下已发布的学习内容、出勤和报告。这种访问方式由学校和负责的老师继续管理学生账号。',
  'School invitations': '学校邀请',
  'Accept a guardian invitation': '接受监护人邀请',
  'School invitation code': '学校邀请码',
  'I am authorised to receive this child’s published information, and I am signing in with the email the school verified.':
    '我有权接收这个孩子已发布的信息，并且我使用的是学校已验证的邮箱登录。',
  'Confirm your relationship before accepting.': '接受之前请先确认你与孩子的关系。',
  'Checking invitation…': '正在核对邀请…',
  'Accept school invitation': '接受学校邀请',
  'This does not move the student to your Family, grant Study consent or change Stars or payments. Ask the school to revoke access if the relationship changes.':
    '这不会把学生转入你的家庭，不会授予学习同意，也不会改变星星或付款。如果关系发生变化，请让学校撤销访问权限。',
  'School relationship verified.': '学校关系已验证。',
  'Loading school relationships…': '正在加载学校关系…',
  'No verified school relationships yet': '还没有已验证的学校关系',
  'Ask your school or tutor for an invitation. A tuition payment or an enquiry does not automatically give learning access.':
    '请向学校或老师索取邀请。缴纳学费或提交咨询并不会自动获得学习访问权限。',
  'Child and school': '孩子和学校',
  'Loading published school information…': '正在加载已发布的学校信息…',
  'This school relationship is unavailable or has been revoked. Published information cannot be retrieved with this access.':
    '这个学校关系已不可用或已被撤销，无法通过此访问权限获取已发布的信息。',
  'Refresh access': '刷新访问权限',
  'Upcoming lessons': '即将开始的课节',
  'No lessons scheduled in the next two weeks.': '未来两周没有安排课节。',
  'Assigned work and published feedback': '布置的作业和已发布的反馈',
  'Due {date}': '截止 {date}',
  Excused: '已豁免',
  'Returned for revision': '已退回修改',
  'Feedback published': '反馈已发布',
  'Published submitted response': '已发布的提交内容',
  'This published image is unavailable. Refresh your school access.':
    '这张已发布的图片暂时无法查看，请刷新你的学校访问权限。',
  'View published image {number}': '查看已发布的图片 {number}',
  'saved version {version}': '已保存版本 {version}',
  'No published feedback yet. Drafts and private teacher notes stay private.':
    '还没有已发布的反馈。草稿和老师的私人备注不会公开。',
  'No published assignments in the current class scope.': '当前班级范围内还没有已发布的作业。',
  Attendance: '出勤',
  'No attendance records available.': '暂无出勤记录。',
  'Published progress reports': '已发布的进度报告',
  'Published {date}': '发布于 {date}',
  'Feedback only': '仅有反馈',
  '{count} finalised attendance records in this report.': '本报告包含 {count} 条已确认的出勤记录。',
  'The school has not published a report for this relationship yet.':
    '学校还没有为这个关系发布报告。',
  'School notices': '学校通知',
  'Available in your school inbox': '可在你的学校收件箱查看',
  'Acknowledge notice': '确认已读',
  'No school notices in this view.': '这里没有学校通知。',
  'Published submitted evidence': '已发布的提交作品',
  'Your school already pays for Study for this child. You do not need to buy it.':
    '你的学校已经为这个孩子支付了学习费用，你不需要再购买。',
  'Checkout status is uncertain. Do not start a different payment; retry or check this order.':
    '结账状态不确定。请不要另外发起付款，请重试或查看这笔订单。',
  'Could not confirm checkout. Retry with the same request.':
    '无法确认结账结果。请用同一个请求重试。',
  'Airbotix Study': 'Airbotix 学习',
  'Study access for you': '你的学习权限',
  'Study access for your child': '孩子的学习权限',
  'Payment and access are confirmed separately. Exam Practice Packs are not included.':
    '付款和开通权限分别确认。不包含备考练习包。',
  'Choose one child. Payment and access are confirmed separately. Exam Practice Packs are not included.':
    '请选择一个孩子。付款和开通权限分别确认。不包含备考练习包。',
  'We cannot confirm this order yet': '暂时无法确认这笔订单',
  'Do not start another payment. Check this order again.': '请不要再发起付款，请重新查看这笔订单。',
  'Check order': '查看订单',
  'Clear unavailable order': '清除不可用的订单',
  'Study access is active': '学习权限已开通',
  'You can use Study until {date}.': '你可以使用学习功能，直到 {date}。',
  'The selected child can use Study until {date}.': '所选孩子可以使用学习功能，直到 {date}。',
  'Open Study': '打开学习',
  'Back to family Home': '返回家庭首页',
  'Purchase for another child': '为另一个孩子购买',
  'This Study access is no longer active': '这项学习权限已失效',
  'The earlier payment remains in your order history. A new purchase creates a separate order.':
    '之前的付款仍保留在你的订单记录中。重新购买会生成一笔新的订单。',
  'Start a new purchase': '重新购买',
  'This order was refunded': '这笔订单已退款',
  'Payment received; access is not active': '已收到付款，但权限尚未开通',
  'Do not pay again. This order needs review before you can use it.':
    '请不要重复付款。这笔订单需要审核后你才能使用。',
  'Do not pay again. This order needs review before your child can use it.':
    '请不要重复付款。这笔订单需要审核后孩子才能使用。',
  'Waiting for payment confirmation': '正在等待付款确认',
  'Keep this order open. Access starts only after payment is confirmed.':
    '请保持此订单页面打开。付款确认后才会开通权限。',
  'Choose your Study plan': '选择你的学习方案',
  'Choose the learner': '选择学习者',
  'Loading your options…': '正在加载可选项…',
  'Could not load purchase options.': '无法加载购买选项。',
  'Study access is not available to purchase yet.': '学习权限暂时还不能购买。',
  'Study product': '学习产品',
  Learner: '学习者',
  'You already have active Study access.': '你已经开通了学习权限。',
  'This child already has active Study access.': '这个孩子已经开通了学习权限。',
  'Your school': '你的学校',
  '{name} already pays for Study for this child through school fees until {date}. You do not need to buy it.':
    '{name}已通过学费为这个孩子支付学习费用，有效期至 {date}。你不需要再购买。',
  '{name} already pays for Study for this child through school fees. You do not need to buy it.':
    '{name}已通过学费为这个孩子支付学习费用。你不需要再购买。',
  'Opening checkout…': '正在打开结账页…',
  'Continue to secure checkout': '继续前往安全结账',
  'Airwallex handles payment details. Airbotix confirms the order before granting access.':
    '付款信息由 Airwallex 处理。Airbotix 确认订单后才会开通权限。',
  'Loading order…': '正在加载订单…',
  'This exam product is not available for purchase.': '这款备考产品暂不可购买。',
  'Browse exam prep': '浏览备考产品',
  'Could not check this order': '无法查看这笔订单',
  'Your payment status is still unknown': '你的付款状态仍不明确',
  'Do not pay again. Check the existing order before you start another checkout.':
    '请不要重复付款。重新结账之前，请先查看现有订单。',
  'Check order again': '再次查看订单',
  'Payment is confirmed. Open it from My Exam Prep.': '付款已确认。请从“我的备考”中打开。',
  'Payment is confirmed. The selected child can now open it from My Exam Prep.':
    '付款已确认。所选孩子现在可以从“我的备考”中打开。',
  'Open My Exam Prep': '打开我的备考',
  'My exam products': '我的备考产品',
  'Payment received': '已收到付款',
  'Access is still being prepared': '权限仍在准备中',
  'Your payment succeeded, but the access has not appeared yet. Do not pay again.':
    '你的付款已成功，但权限还没有出现。请不要重复付款。',
  'Check access again': '再次检查权限',
  'Unlocking {title}': '正在解锁{title}',
  "We're waiting for payment confirmation. Don't pay again; access unlocks automatically.":
    '我们正在等待付款确认。请不要重复付款，权限会自动解锁。',
  'Checking access': '正在检查权限',
  'We’re checking whether you already own this product.': '我们正在检查你是否已经拥有这款产品。',
  'We’re loading your children and checking who already owns this product.':
    '我们正在加载你的孩子列表，并检查谁已经拥有这款产品。',
  'Could not check access': '无法检查权限',
  "We couldn't load the learner list.": '无法加载学习者列表。',
  "We couldn't check who already owns this product.": '无法检查谁已经拥有这款产品。',
  'Checkout will stay hidden until the check succeeds.': '检查成功之前，不会显示结账入口。',
  'Add a child first': '请先添加孩子',
  'This product belongs to one child, but your family profile has no children yet.':
    '这款产品只属于一个孩子，但你的家庭资料里还没有孩子。',
  'Exam prep checkout': '备考结账',
  Product: '产品',
  '{questions} reviewed questions · {days} days access':
    '{questions} 道已审核的题目 · {days} 天使用权限',
  Total: '合计',
  'Who is this exam prep for?': '这份备考是给谁的？',
  '{name} (age {age}) — already unlocked': '{name}（{age} 岁）— 已解锁',
  '{name} (age {age})': '{name}（{age} 岁）',
  'Opening secure checkout…': '正在打开安全结账页…',
  'Pay {amount} →': '支付 {amount} →',
  'Access is added to your account only after payment is confirmed.':
    '付款确认后，权限才会添加到你的账号。',
  'Access is granted to the selected child only after payment is confirmed.':
    '付款确认后，权限才会开通给所选的孩子。',
  '5-minute sample paper': '5 分钟样卷',
  'Try the full mock-exam loop.': '体验完整的模拟考试流程。',
  'Three original questions: two are marked automatically and one is self-assessed against a rubric after submission. Answers and marking guidance stay locked during the paper.':
    '三道原创题目：两道自动批改，一道在提交后对照评分标准自评。答题期间，答案和评分指引保持锁定。',
  'Start sample paper': '开始做样卷',
  'Objective marks': '客观题得分',
  'Automatically marked': '自动批改',
  'Self-assessed marks': '自评得分',
  'Based on rubric ticks': '根据评分标准勾选',
  'Total marks': '总分',
  'Kept separate': '分开计算',
  'Post-submit marking guide': '提交后的评分指引',
  'Question 3 · Worked response': '第 3 题 · 解答过程',
  'Your response: {response}': '你的作答：{response}',
  'No response': '未作答',
  'Sample solution:': '参考解答：',
  'Tick each point your working demonstrates': '勾选你的解答体现了的每一个得分点',
  '1 mark': '1 分',
  'Restart demo': '重新开始',
  'Mock exam mode': '模拟考试模式',
  'Question {number} of {total} · {marks} marks': '第 {number} 题，共 {total} 题 · {marks} 分',
  '04:59 remaining': '剩余 04:59',
  'Worked response': '解答过程',
  'Show your working here…': '在这里写出你的解题过程…',
  'No correctness or marking guide is shown until the whole paper is submitted.':
    '整份试卷提交之前，不会显示对错或评分指引。',
  Previous: '上一题',
  'Save and next': '保存并进入下一题',
  'Submit sample paper': '提交样卷',
  'Loading product details…': '正在加载产品详情…',
  'Please try again': '请重试',
  "We couldn't load this exam product right now.": '暂时无法加载这款备考产品。',
  'Back to Exam Prep': '返回备考',
  '{level} {subject} practice with help when they get stuck.':
    '{level} {subject}练习，卡住时有人帮。',
  'Your child works through reviewed, Year-specific questions and gets immediate feedback. After every attempt, Airo Tutor automatically explains the thinking in small steps.':
    '孩子做经过审核、按年级划分的题目，并立即得到反馈。每次作答之后，Airo 导师会自动分步骤讲解解题思路。',
  '{days} days · one child': '{days} 天 · 限一个孩子',
  'Checking your family’s access…': '正在检查你家庭的权限…',
  'Unlocked for {names}': '已为 {names} 解锁',
  'Buy for me →': '为我购买 →',
  'Choose another child →': '选择另一个孩子 →',
  'Choose a child →': '选择孩子 →',
  'Set up your family →': '设置你的家庭 →',
  'Try the experience': '体验一下',
  'See the question and the Tutor together.': '一起看看题目和导师。',
  'Switch between untimed practice with immediate Tutor feedback and a timed sample paper that keeps answers locked until submission.':
    '可以在不限时的练习（导师即时反馈）和限时样卷（提交前答案保持锁定）之间切换。',
  'Demo mode': '体验模式',
  'Practice mode': '练习模式',
  '{count} questions available': '共 {count} 道题',
  'Practice stays inside {level} {subject}; there is no Year switching inside the player.':
    '练习只在{level} {subject}范围内；练习界面里不能切换年级。',
  'Feedback after every answer': '每道题作答后都有反馈',
  'The answer is checked immediately, and every attempt contributes to the child’s progress.':
    '答案会立即批改，每一次作答都会计入孩子的进度。',
  'Airo Tutor is included': '包含 Airo 导师',
  'It explains what the question asks, why the method works, where thinking may have slipped, and what to try next.':
    '它会讲解题目在问什么、方法为什么有效、思路可能在哪里出了偏差，以及下一步可以怎么尝试。',
  'What happens after purchase?': '购买之后会怎样？',
  '1. Assign one child': '1. 指定一个孩子',
  'The product is fixed to that child and Year.': '产品会固定给该孩子和对应年级。',
  '2. Start in My Exam Prep': '2. 在“我的备考”中开始',
  'Your child opens the product from their own account.': '孩子从自己的账号打开产品。',
  '3. Practise and ask why': '3. 练习，并追问为什么',
  'Answers, progress, and Tutor explanations stay in one flow.':
    '答案、进度和导师讲解都在同一个流程里。',
  'Checking order': '正在查看订单',
  'Loading the latest payment and access status…': '正在加载最新的付款和权限状态…',
  'Your payment status is unknown. Do not pay again until this order can be checked.':
    '你的付款状态不明确。在能查看这笔订单之前，请不要重复付款。',
  'Exam prep is ready': '备考产品已就绪',
  "Payment is confirmed and the product is now available in your child's My Exam Prep.":
    '付款已确认，产品现已出现在孩子的“我的备考”中。',
  "Payment succeeded, but the child's exam access has not appeared yet. Do not pay again.":
    '付款已成功，但孩子的备考权限还没有出现。请不要重复付款。',
  'Payment not completed': '付款未完成',
  'No exam access was granted. You can try again safely.':
    '没有开通任何备考权限。你可以放心重新尝试。',
  "Please wait while we confirm payment and unlock the product. Don't pay again.":
    '请稍候，我们正在确认付款并解锁产品。请不要重复付款。',
  'Your family’s Study': '你家庭的学习',
  'See what your child tried, how the Tutor helped and what they could do independently.':
    '看看孩子尝试了什么、导师怎样帮忙，以及孩子能独立做到什么。',
  'Parent Study categories': '家长学习分类',
  'Study access': '学习权限',
  'Choose a child’s Study records': '选择孩子的学习记录',
  'Choose your child': '选择你的孩子',
  'Each report keeps learning records, Tutor support and Study settings together.':
    '每份报告把学习记录、导师辅导和学习设置放在一起。',
  'Add a child to see their Study records.': '添加孩子后即可查看学习记录。',
  'Open family Home': '打开家庭首页',
  'Attempts, help used, independent checks and next steps.':
    '尝试情况、使用过的帮助、独立检查和下一步。',
  'View {name}’s Study': '查看{name}的学习',
  'Records show activity and available evidence. Completing work with help does not establish independent ability.':
    '记录展示的是学习活动和现有的依据。借助帮助完成作业，并不代表已经能独立完成。',
  'Guide language': '指南语言',
  Filters: '筛选',
  'All topics': '全部主题',
  Location: '地点',
  'All locations': '全部地点',
  'Loading guides…': '正在加载指南…',
  'Guides are catching their breath': '指南正在喘口气',
  "We couldn't load the guide library just now — the rest of the Portal is fine. You can browse every guide on our website instead.":
    '暂时无法加载指南库，家长中心的其他部分一切正常。你可以改到我们的网站浏览全部指南。',
  'Visit the resources hub →': '访问资源中心 →',
  'No guides published yet': '还没有已发布的指南',
  'The Portal guide library is empty. You can still browse our public resources hub.':
    '家长中心的指南库目前是空的。你仍然可以浏览我们的公开资源中心。',
  'No matches': '没有匹配的结果',
  'No guides match these filters yet — try widening them.':
    '暂时没有符合这些筛选条件的指南，试试放宽条件。',
  'Clear filters': '清除筛选',
  'Showing {shown} of {total} guides.': '显示 {shown} / {total} 份指南。',
  'More guides load automatically as you scroll.': '向下滚动时会自动加载更多指南。',
  'Checked {date}': '核对于 {date}',
  'Read guide →': '阅读指南 →',
  'Download PDF': '下载 PDF',
  'View all →': '查看全部 →',
  'Picked for your family': '为你的家庭精选',
  'Choose a sample question': '选择一道样题',
  'Equal groups': '等量分组',
  Money: '货币',
  Data: '数据',
  'Question {number} of {total}': '第 {number} 题，共 {total} 题',
  'Tap an answer to see how Airo Tutor explains it.': '点选一个答案，看看 Airo 导师怎么讲解。',
  'Correct — {answer} is the answer.': '答对了，答案是 {answer}。',
  '{answer} isn’t the answer yet — let’s work it out together.':
    '{answer} 还不是答案，我们一起来想一想。',
  'Airo Tutor demo': 'Airo 导师体验',
  "Let's make it click.": '一起把它想明白。',
  'A hint before you answer': '作答前的提示',
  'Correct — here’s why': '答对了，原因如下',
  'Good try — here’s how': '试得不错，思路如下',
  'What is the question asking?': '题目在问什么？',
  'Step 1 · How to think': '第 1 步 · 怎么想',
  'Step 2 · Work it out': '第 2 步 · 算出来',
  'Why this answer is correct': '为什么这个答案是对的',
  'What you understood': '你理解了什么',
  'Where your thinking may have slipped': '思路可能在哪里出了偏差',
  'Quick check': '快速检查',
  'In the purchased product, this explanation appears automatically after each attempt.':
    '购买产品后，每次作答之后都会自动出现这样的讲解。',
  'NAPLAN Numeracy prep for families': '面向家庭的 NAPLAN 数学备考',
  'Help your child practise with the questions that match their Year.':
    '用与孩子年级匹配的题目，帮助孩子练习。',
  'Airbotix Academy gives your child a focused place to build Numeracy confidence at home. Choose their NAPLAN Year, unlock it for one child, and let them work through practice at their own pace.':
    'Airbotix Academy 为孩子提供一个专注的地方，在家建立数学自信。选择孩子的 NAPLAN 年级，为一个孩子解锁，让孩子按自己的节奏练习。',
  "Choose your child's Year ↓": '选择孩子的年级 ↓',
  'How NAPLAN practice works': 'NAPLAN 练习如何进行',
  'A simple routine at home': '在家的简单流程',
  'You choose the Year': '你选择年级',
  'No switching between levels.': '不会在不同级别之间切换。',
  'Your child answers': '孩子作答',
  'One focused Numeracy question at a time.': '每次专注做一道数学题。',
  'Progress is recorded': '进度会被记录',
  'See attempts, correct answers and accuracy.': '可以看到尝试次数、答对数量和正确率。',
  'What you are buying': '你购买的内容',
  'Focused practice, without mixing Years.': '专注的练习，不混杂不同年级。',
  "This is a self-paced practice product for home use. It supports regular Numeracy practice; it does not replace your child's school or guarantee an exam result.":
    '这是一款供在家使用、可自定节奏的练习产品，用于支持日常的数学练习；它不能取代孩子的学校教育，也不保证考试成绩。',
  'The right Year, every time': '每次都是合适的年级',
  'Choose Year 3, 5, 7 or 9 before you buy. Your child practises only inside that product.':
    '购买前先选择 3、5、7 或 9 年级。孩子只会在该产品内练习。',
  'Clear feedback after each answer': '每道题作答后都有清晰的反馈',
  'Children can practise independently and see whether they understood the question.':
    '孩子可以独立练习，并看到自己是否理解了题目。',
  'Progress that stays visible': '进度一目了然',
  'Completed questions, correct answers and accuracy are saved inside the chosen product.':
    '已完成的题目、答对数量和正确率都会保存在所选的产品里。',
  'Each purchase unlocks one Year-level product for one child. Your child opens it from {product} after payment is confirmed.':
    '每次购买为一个孩子解锁一个年级的产品。付款确认后，孩子可从{product}中打开。',
  'My Exam Prep': '我的备考',
  'Recent mock exam reports': '近期模拟考试报告',
  'Objective and self-assessed marks shown separately →': '客观题与自评得分分开显示 →',
  'Loading exam products…': '正在加载备考产品…',
  'Checking your family’s exam access…': '正在检查你家庭的备考权限…',
  "We couldn't load NAPLAN products right now.": '暂时无法加载 NAPLAN 产品。',
  'Access check failed': '权限检查失败',
  "We couldn't check which exam products your children already own. Purchase options will stay hidden until this check succeeds.":
    '无法检查你的孩子已经拥有哪些备考产品。检查成功之前，不会显示购买选项。',
  '{exam} Numeracy': '{exam} 数学',
  'Which Year are you preparing for?': '你在备考哪个年级？',
  'Which Year is your child preparing for?': '孩子在备考哪个年级？',
  'Choose carefully: each Year is a separate product and stays on your account.':
    '请谨慎选择：每个年级都是单独的产品，并保留在你的账号下。',
  'Choose carefully: each Year is a separate product and stays fixed for the child you select at checkout.':
    '请谨慎选择：每个年级都是单独的产品，并固定给你在结账时选择的孩子。',
  'NAPLAN products will appear here once they are ready.': 'NAPLAN 产品准备好后会显示在这里。',
  'Before you buy': '购买之前',
  'What happens next?': '接下来会怎样？',
  '1. Choose a Year': '1. 选择年级',
  'Pick the product that matches your child.': '选择适合孩子的产品。',
  '2. Choose a child': '2. 选择孩子',
  "Access belongs to that child's profile.": '权限属于该孩子的个人档案。',
  '3. Start practising': '3. 开始练习',
  'They open it from My Exam Prep.': '孩子从“我的备考”中打开。',
  'Frozen weekly reports': '已固定的每周报告',
  'Past weeks stay fixed': '过去的每周记录保持不变',
  'The previous completed week is saved automatically; opening this page also catches up if needed. New activity does not rewrite it.':
    '上一个完整的一周会自动保存；打开本页时也会在需要时补上。之后的新活动不会改写它。',
  'Loading weekly reports…': '正在加载每周报告…',
  'Weekly reports are unavailable right now.': '暂时无法查看每周报告。',
  'No completed week is available yet.': '还没有可查看的完整一周记录。',
  'Week of {date}': '{date}当周',
  opened: '已打开',
  new: '新',
  'Opening this week…': '正在打开这一周…',
  'Could not open this report.': '无法打开这份报告。',
  'Selected weekly report': '所选的每周报告',
  'Frozen revision {revision} · no evidence': '固定版本 {revision} · 没有学习记录',
  'Frozen revision {revision} · limited evidence': '固定版本 {revision} · 记录有限',
  'Frozen revision {revision} · ready evidence': '固定版本 {revision} · 记录充足',
  '{sessions} Study Sessions · {questions} practice questions · {days} active days':
    '学习 {sessions} 次 · 练习题 {questions} 道 · 活跃 {days} 天',
  'Compared with the preceding week: {sessions} sessions · {questions} practice questions · {days} active days. These are activity changes, not grades or mastery.':
    '与前一周相比：学习次数 {sessions} · 练习题 {questions} · 活跃天数 {days}。这些是活动量的变化，不是成绩或掌握程度。',
  'Loading the exam report…': '正在加载考试报告…',
  'Report unavailable': '暂时无法查看报告',
  'Back to Academy': '返回 Academy',
  'Academy report': 'Academy 报告',
  'Mock exam result': '模拟考试结果',
  'Objective marks and learner self-assessment are shown separately so the report never presents a self-awarded mark as measured accuracy.':
    '客观题得分和学习者的自评分开显示，报告不会把自评的分数当作实测的正确率。',
  'Objective score': '客观题得分',
  '{percent}% objective accuracy': '客观题正确率 {percent}%',
  'Self-assessed': '自评',
  'The learner checked this against the official marking guide': '学习者对照官方评分指引自行核对',
  'Combined marks': '合计得分',
  'A mark total, not a combined accuracy percentage': '这是得分总和，不是合并后的正确率',
  'English learning process': '英语学习过程',
  'English · learning process': '英语 · 学习过程',
  'What Tutor helped your child practise': '导师帮孩子练习了什么',
  'Look for their own attempt, teaching, retry and a response to a different text. Support use and answer quality are separate: a saved answer is not proof of improvement.':
    '请留意孩子自己的尝试、导师的讲解、再次尝试，以及对另一篇文本的回应。帮助的使用和答案的质量是两回事：保存下来的答案并不能证明进步。',
  'Up to 8 recent English trial records updated in the last 30 days. Private quotations, answers and Tutor conversations are excluded.':
    '显示最近 30 天内更新的英语试用记录，最多 8 条。不含私人引文、答案和导师对话。',
  'Loading English process records…': '正在加载英语学习过程记录…',
  'English process records are unavailable. This does not mean your child has done no learning.':
    '暂时无法查看英语学习过程记录。这并不代表孩子没有学习。',
  'Reload English process': '重新加载英语学习过程',
  'No English trial process is recorded in this window. The trial also requires reviewed, published materials; missing records are not a zero score.':
    '这段时间内没有英语试用的学习过程记录。试用还需要经过审核并发布的材料；缺少记录不等于零分。',
  '{attempts} attempts · {checks} submitted checks': '尝试 {attempts} 次 · 提交检查 {checks} 次',
  'Original trial material v{version}': '原创试用材料 v{version}',
  'Later check': '之后的检查',
  'Practice and different text check': '练习，以及换一篇文本的检查',
  'Learning timeline': '学习时间线',
  'Started a practice text': '开始了一篇练习文本',
  'Saved their own reasoning / retry': '保存了自己的推理 / 再次尝试',
  'Requested Tutor teaching': '请求了导师讲解',
  'Received Tutor teaching': '收到了导师讲解',
  'Tutor request did not complete': '导师请求未能完成',
  'Started a different text': '开始了另一篇文本',
  'Submitted a check': '提交了一次检查',
  'Started a later check': '开始了之后的检查',
  'Educator reviewed the submitted check': '教育工作者审核了提交的检查',
  'Viewed a worked example': '查看了示范例子',
  'Withdrew educator sharing': '撤回了对教育工作者的分享',
  'word meaning': '词义',
  'finding evidence': '寻找依据',
  'explaining the connection': '解释其中的联系',
  'a different example': '换一个例子',
  'checking reasoning': '检查推理',
  'A different-text check has not been submitted. Independent application is still unknown.':
    '还没有提交换一篇文本的检查。能否独立运用仍然未知。',
  'Different text check': '换一篇文本的检查',
  'support used': '用到了帮助',
  'no platform help recorded': '没有记录到平台帮助',
  'Educator review recorded. These criteria describe this response; they do not establish mastery or improvement.':
    '已记录教育工作者的审核。这些标准只描述这一次回答，并不能说明已经掌握或有进步。',
  'Answer quality: awaiting educator review. No platform help recorded is not proof of correctness or a claim about help outside Airbotix.':
    '答案质量：等待教育工作者审核。“没有记录到平台帮助”并不能证明答案正确，也不代表没有在 Airbotix 之外得到帮助。',
  'Answers the question': '回答了问题',
  'Relevant exact evidence': '引用了相关的准确依据',
  'Explains the connection': '解释了其中的联系',
  'Recognises inference limits': '意识到推断的局限',
  '{label}: {value}': '{label}：{value}',
  'not recorded': '未记录',
  'Later check available {date}.': '之后的检查可在 {date} 进行。',
  'Text difficulty comparability is not established.': '文本难度是否可比尚未确定。',
  'At home: ask your child to explain why one action supports their interpretation, without requesting a finished answer.':
    '在家时：请孩子解释为什么某个行为支持他们的解读，而不是要一个现成的答案。',
  '{subject} practice': '{subject}练习',
  'Questions matched to {level}': '与{level}匹配的题目',
  '{count} practice questions available now': '现有 {count} 道练习题',
  'Immediate answer feedback': '答题后立即反馈',
  'Attempts and accuracy recorded': '记录尝试次数和正确率',
  'Already unlocked for {names}': '已为 {names} 解锁',
  'Choose {title} for a child': '为孩子选择{title}',
  'View product →': '查看产品 →',
  'See {level} →': '查看{level} →',
  Unavailable: '不可用',
  '{name} Study report': '{name}学习报告',
  '{name} logo': '{name}标志',
  "{name}'s Study week": '{name}本周的学习',
  '{start} to {end}': '{start} 至 {end}',
  'Tool uses': '工具使用次数',
  'Checked answers correct': '已核对答案的正确数',
  'None checked': '没有核对过的答案',
  '{correct} of {checked}': '{checked} 个中答对 {correct} 个',
  Subjects: '学科',
  '{tools} tool uses · {questions} practice questions · {turns} Tutor turns':
    '工具使用 {tools} 次 · 练习题 {questions} 道 · 导师回应 {turns} 次',
  'Tasks from the Institution': '机构布置的任务',
  'Tasks from {name}': '来自{name}的任务',
  'Not started': '未开始',
  Started: '已开始',
  "Counts only. Mastery levels are not assessed yet. This report does not include Tutor conversations, answers, uploaded files or {name}'s private Study.":
    '仅显示次数。目前不评估掌握程度。这份报告不含导师对话、答案、上传的文件，也不含{name}的私人学习内容。',
  'Link available until {date}.': '链接有效期至 {date}。',
  'Powered by {name}': '由 {name} 提供技术支持',
  "Reports from your child's school": '来自孩子学校的报告',
  'From the school': '来自学校',
  'Shared Study reports': '共享的学习报告',
  'Optional. We use this to understand which school communities Airbotix reaches.':
    '选填。我们用它来了解 Airbotix 触达了哪些学校社区。',
  'State (optional)': '州（选填）',
  'School (optional)': '学校（选填）',
  'Start typing a school name…': '输入学校名称…',
  'Suburb: {suburb} · matched to the school directory': '所在区域：{suburb} · 已与学校名录匹配',
  'Suburb: {suburb}': '所在区域：{suburb}',
  'The school has withdrawn this report link. Ask the school for a new link.':
    '学校已撤回这个报告链接。请向学校索取新的链接。',
  'This report link has expired. Ask the school for a new link.':
    '这个报告链接已过期。请向学校索取新的链接。',
  'This report link is not valid. Check that you copied the whole link.':
    '这个报告链接无效。请确认你复制了完整的链接。',
  'Opening the Study report…': '正在打开学习报告…',
  'Report not available': '报告不可用',
  'Browse the library': '浏览指南库',
  'Completed||on date': '完成于',
};
